import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;
var timer = -1;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


export default function SpringAr({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac
  //4 = multiple choice 2
  
  //questions section
  var questionsY1Spring = [];
  questionsY1Spring.push({ "question" : "3 + 6 =", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "8 – 0 =", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "5 + _ = 20", "answer" : "15", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "Add together eleven and six.", "answer" : "17", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "17 – 16 =", "answer" : "1", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "12 = 5 + _", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "_ + 4 = 13 + 3", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "11 is one more than", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "16 - 2 = _ - 1", "answer" : "15", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "20 – 9 =", "answer" : "11", "type": 0, "units" : "", "marks" : 1})

  
  


  var questionsY2Spring = [];
  questionsY2Spring.push({ "question" : "4 + 7 = ", "answer" : "11", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "16 – 4 =", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "_ = 19 - 2", "answer" : "17", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "One less than forty-four =", "answer" : "43", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "30 + _ = 100", "answer" : "70", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "8 × 2 =", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "6 + _ + 3 = 15", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "6 ÷ 6 =", "answer" : "1", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "1/2 of 16 =", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "10 + 10 + 10 + 10 =", "answer" : "40", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "1/4 of 20 = ", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "82 – 44 =", "answer" : "38", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "27 + 47 =", "answer" : "74", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "3/4 of 16 =", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY2Spring.push({ "question" : "44 + 13 = 100 – _", "answer" : "43", "type": 0, "units" : "", "marks" : 1})

  
  

  var questionsY3Spring = [];
  questionsY3Spring.push({ "question" : "54 + 34 = ", "answer" : "88", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "244 - 121 = ", "answer" : "123", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "456 + 10 = ", "answer" : "466", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "5 x 5 = ", "answer" : "25", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "16 + 5 + 4 =", "answer" : "25", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "799 - 100 =", "answer" : "699", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "45 ÷ _ = 9", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "85 - 16 = ", "answer" : "69", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "24 x 8 = ", "answer" : "192", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "1/2 of 38 cm = _cm", "answer" : "19", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "78 + _ – 33 = 65", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "3/4 of 120 =", "answer" : "90", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "594 + 246 =", "answer" : "840", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "3 ÷ _ = 3/10", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "20p + 85p = £1 + _p", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "345 – 78 =", "answer" : "267", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "1/4 of 24 = 1/2 of ____", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "4 x _ = 32 ÷ 8", "answer" : "1", "type": 0, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "500 - _ = 4 x 47", "answer" : "312", "type": 0, "units" : "", "marks" : 1})

  

  var questionsY4Spring = [];
  questionsY4Spring.push({ "question" : "350 + 100 =", "answer" : "450", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "5 x 9 =", "answer" : "45", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "3 x 4 x 2 =", "answer" : "24", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "48 ÷ 6 =", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "8 x 4 x 2 = ", "answer" : "64", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "3/7 + 2/7 =", "answer" : "5/7", "type": 2, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : " _ = 4,450 + 1,650", "answer" : "6100", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "1/4 of 24 =", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "1 - 4/9 =", "answer" : "5/9", "type": 2, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "38 x 7 = ", "answer" : "266", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "81 ÷ 3 =", "answer" : "27", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "5,609 - 1,996 = ", "answer" : "3613", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "5/13 + 11/13 = _ + 4/13", "answer" : "12/13", "type": 2, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "108 ÷ 9 =", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "123 x 6 = ", "answer" : "738", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "2/3 of £33 = £_ ", "answer" : "22", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "65/100 - _ = 0.48", "answer" : "0.17", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "123 x 8 = 1,230 - _", "answer" : "246", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "3/5 of _ = 75 ", "answer" : "125", "type": 0, "units" : "", "marks" : 1})
  
  


  var questionsY5Spring = [];
  questionsY5Spring.push({ "question" : "605 – 100 =", "answer" : "505", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "99 + 456 =", "answer" : "555", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "48 ÷ _ = 6", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "26 × 4 =", "answer" : "104", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "2/3 of 63km = _km", "answer" : "42", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "3,476 + 2,339 =", "answer" : "5815", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "1/7 + 3/7 = ", "answer" : "4/7", "type": 2, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "19 × 0 × 8 =", "answer" : "0", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "7,234 – 1,000 = _ + 5,234", "answer" : "1000", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "2/11 x 5 =", "answer" : "10/11", "type": 2, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "10,000 – 5,567 =", "answer" : "4433", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "2^3 + 5^2 = ", "answer" : "33", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "21 × 100 =", "answer" : "2100", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "3/8 - 1/4 = ", "answer" : "1/8", "type": 2, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "744 ÷ 8 =", "answer" : "93", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "13 × 365 =", "answer" : "4745", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "507 × 7 = _ + 1,642", "answer" : "1907", "type": 0, "units" : "", "marks" : 1})

  

  
  var questionsY6Spring = [];
  questionsY6Spring.push({ "question" : "460 + 100 =", "answer" : "560", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "4 × 9 =", "answer" : "36", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "6,346 – 1,213 =", "answer" : "5133", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "5^2 =", "answer" : "25", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "5 × 4 × 3 =", "answer" : "60", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "85 × 5 =", "answer" : "425", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "48 ÷ 4 =", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "3/7 + 3/7 =", "answer" : "6/7", "type": 2, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "3.2 × 100 =", "answer" : "320", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "1/2 + 1/4 =", "answer" : "3/4", "type": 2, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "89,255 + 2,078 =", "answer" : "91333", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "7/10 of 70 =", "answer" : "49", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "4.5 + 3.021 =", "answer" : "7.521", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "10 + 3 × 7 =", "answer" : "31", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "274 × 24 =", "answer" : "6576", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "1/7 ÷ 2 = ", "answer" : "1/14", "type": 2, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "0.7 × 60 =", "answer" : "42", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "2,465 ÷ 17 =", "answer" : "145", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "20% of 280 =", "answer" : "56", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "5 - 1&3/7 =", "answer" : "3&4/7", "type": 3, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "2/3 x 4/9 = ", "answer" : "8/27", "type": 2, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "0.6 ÷ 100 =", "answer" : "0.006", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "1&5/6 x 30 =", "answer" : "55", "type": 0, "units" : "", "marks" : 1})

  


//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  

  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    //check what questions it is, checking year first will check terms later like Spring etc
    if (props.assessment_type[0] == "1"){
      timer = -1;
      setQuestions(questionsY1Spring);
    } else if (props.assessment_type[0] == "2"){
      timer = -1;
      setQuestions(questionsY2Spring);
    } else if (props.assessment_type[0] == "3"){
      timer = 1200;
      setQuestions(questionsY3Spring);
    } else if (props.assessment_type[0] == "4"){
      timer = 1200;
      setQuestions(questionsY4Spring);
    } else if (props.assessment_type[0] == "5"){
      timer = 1500;
      setQuestions(questionsY5Spring);
    } else if (props.assessment_type[0] == "6"){
      timer = 1500;
      setQuestions(questionsY6Spring);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    var requireString = "Year"+props.assessment_type[0];
    if (props.assessment_type[3] == "ar"){
      requireString+= "/ARSpringEnd";
    }else if (props.assessment_type[4]){
      requireString+= "/RESpringEnd";
    }
    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      var correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     var correct = 0;      
    var questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    var topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
  function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >

            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          position: "relative",
                          top: "15%",
                          right: "5%",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            MultipleButtons()
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                          
                        </div>
                    </div>
                    
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButton = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    right: -1000px;
    top: 150px
    background-image: url(${next});
    color: #000;
    user-select: none;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButtonBack = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    top: 150px;
    right: 1000px
    background-image: url(${back});
    color: #000;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`